module.exports = __webpack_public_path__ + "img/9cloud.logo.144.d51ee04a.png";